import { HStack, Text } from '@chakra-ui/layout';
import { Avatar } from '@chakra-ui/avatar';
import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/menu';
import { useRouter } from 'next/router';

import { ResponsiveButton } from '@/uikit/component/Button';
import { useUserStore } from '@/modules/user/userStore';

type LoginButtonProps = {
  width?: string | number;
};

const LoginButton: React.FC<LoginButtonProps> = ({ width }) => {
  const router = useRouter();

  const handleRedirect = (url: string) => {
    const redirectURL = encodeURIComponent(window.location.href);
    router.push(`${url}?redirect_url=${redirectURL}`);
  };

  return (
    <HStack>
      <ResponsiveButton
        onClick={() => handleRedirect('/login')}
        colorScheme="teal"
        w={width}
      >
        Login
      </ResponsiveButton>
    </HStack>
  );
};

const ProfileNavbar: React.FC = () => {
  const router = useRouter();
  const userStore = useUserStore();

  const onLogout = () => {
    const redirectUrl = encodeURIComponent(window.location.href);
    const logoutPath = router.basePath
      ? `${router.basePath}/logout`
      : '/logout';
    window.location.replace(`${logoutPath}?redirect_url=${redirectUrl}`);
  };

  return userStore.user ? (
    <Menu>
      <HStack spacing={3}>
        <Text d={['none', 'block']} textStyle="title-lg">
          {userStore.user?.name}
        </Text>
        <MenuButton
          as={Avatar}
          name={userStore.user?.name}
          flexDirection="column"
          cursor="pointer"
          src={userStore.user?.profilePic || '#'}
          h={['2rem', null, '2.625rem']}
          w={['2rem', null, '2.625rem']}
          loading="lazy"
        />
      </HStack>
      <MenuList>
        <MenuItem onClick={onLogout}>Logout</MenuItem>
      </MenuList>
    </Menu>
  ) : (
    <LoginButton />
  );
};

type ProfileNavbarType = typeof ProfileNavbar;
type LoginButtonType = typeof LoginButton;

export type { ProfileNavbarType, LoginButtonType };
export { ProfileNavbar, LoginButton };
